import type { SubscriptionView } from "./subscriptionApi";

// Visibility follows subscriptionAllowsAccess in the account backend.
// The web app independently authorizes the signed-in user and device on entry.
export function getWebAppAccessUntil(
  subscription: Pick<SubscriptionView, "planId" | "status" | "graceUntil" | "expiresAt"> | null,
): number | null {
  if (
    subscription?.planId !== "excellence" ||
    (subscription.status !== "active" && subscription.status !== "grace")
  ) {
    return null;
  }
  const grace = Date.parse(subscription.graceUntil ?? "");
  const expiry = Date.parse(subscription.expiresAt ?? "");
  const deadline = Number.isFinite(grace) ? grace : expiry;
  return Number.isFinite(deadline) ? deadline : null;
}
